import _ from 'lodash'
import React from 'react'

import {
  Alert,
  Col,
  Tab,
  Row,
  ActionButton,
  FormInputCheckbox
} from 'camino-react'

import TicketAssets from 'Components/Tickets/Assets'
import NoticesModal from 'Components/Notices/NoticesModal/NoticesModal'
import TicketCorrespondence from 'Components/Tickets/Correspondence'
import TicketDetails from 'Components/Tickets/Details'
import TicketInvoicing from 'Components/Tickets/Invoicing'
import TicketResourcing from 'Components/Tickets/Resourcing'
import TicketTimesheetCreate from 'Components/Tickets/TicketTimesheets/TicketTimesheetCreate'
import TicketTimesheets from 'Components/Tickets/TicketTimesheets'
import { cloudhelpGet, cloudhelpPost } from 'Utilities/CloudHelp'

const ticketInformationActions = (props) => (
  [
    {
      text: props.ticketButtonStatus,
      onClick: () => {props.watchTicket()}
    },
    {
      text: 'Export As PDF',
      href: props.exportTicketPdf,
      method: "GET"
    }
  ]
)

class TicketShow extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      currentTab: props.tab || 'details',
      showAlert: false,
      alertType: '',
      alertText: '',
      ticket: props.ticket,
      timesheetsLoading: false,
      history: [],
      historyLoading: false,
      modalOpen: false,
      timesheets: {},
      ticketButtonStatus: '',
      displayContactNotice: true,
      watcherOptions: [],
      assignCurrentUser: _.isNull(props.ticket.assignee_user_id)
    }
  }

  componentDidMount () {
    this.getTimesheets()
    this.checkTicketButtonStatus()
    this.getWatchers()
  }

  getTimesheets = () => {
    const { hasRole } = this
    const { flashText, ticket } = this.state

    if (!hasRole('timesheet', 'index')) {
      return null
    }
    this.setState({
      timesheetsLoading: true
    })

    return cloudhelpGet(`/api/tickets/${ticket.id}/timesheets.json`, ticket.problem && `/api/problem/${ticket.id}/timesheets.json`)
      .then((response) => {
        this.setState({
          timesheets: response.data,
          timesheetsLoading: false,
          modalOpen: true
        })
      })
      .catch((error) => {
        const flashMessage = error.response.status === 500 ? "There was an issue retrieving this ticket's timesheets." : flashText

        this.setState({
          flashText: flashMessage,
          timesheetsLoading: false
        })
      })
  }

  closeModal = () => {
    this.setState({ modalOpen: false })
    this.getTimesheets()
  }

  collectHistory = () => {
    const { ticket } = this.state

    this.setState({ historyLoading: true })

    cloudhelpGet(`/api/tickets/${ticket.id}/history`)
      .then((response) => {
        this.setState({
          history: response.data,
          historyLoading: false
        })
      })
      .catch(() => {
        this.setState({ historyLoading: false })
      })
  }

  updateAlert = (showAlert, alertType, alertText) => {
    this.setState({ showAlert, alertType, alertText })
  }

  updateTicket = (ticket) => {
    this.setState({ ticket })
  }

  getWatchers () {
    const { ticket } = this.state

    cloudhelpGet(`/api/clients/${ticket.client_id}/users?calligo_users=true`)
      .then((response) => {
        const newWatchers = _.sortBy(_.map(response.data, user => ({ label: user.name, value: user.email })), 'label')
        this.setState(prevState => ({ watcherOptions: newWatchers }))
      })
  }

  hasRole = (...args) => {
    const { roles } = this.props

    return _.get(roles, args)
  }

  tabClassNames (tabName) {
    const { currentTab } = this.state
    const active = currentTab === tabName

    return `tabs__links ${active ? 'tabs__links--active' : ''}`
  }

  makeCurrentTab (currentTab) {
    this.setState({ currentTab })
  }

  checkTicketButtonStatus () {
    const { paths } = this.props
    if (!this.hasRole('employee')) return;
    const ticketButtonStatusPath = _.get(
      _.find(paths, { name: 'ticketButtonStatusPath' }),
      'path'
    )

    cloudhelpGet(ticketButtonStatusPath)
      .then((response) => {
        const state = response.data.success
        this.setState({ ticketButtonStatus: state })
      })
  }

  render () {
    const {
      hasRole,
      collectHistory,
      updateAlert,
      updateTicket,
      getTimesheets
    } = this
    const {
      timesheetsLoading,
      currentTab,
      timesheets,
      showAlert,
      alertText,
      alertType,
      ticket,
      history,
      historyLoading,
      modalOpen,
      ticketButtonStatus,
      displayContactNotice,
      watcherOptions,
      assignCurrentUser
    } = this.state
    const {
      hasNotices,
      backLink,
      whitelistedBackLinks,
      pageTitle,
      paths,
      ticketNotices,
      ticketProblemNotices,
      serviceGroups,
      ticketProblemId,
      defaultServiceGroupId,
      hasManagedServiceGroup,
      ticket_statuses,
      statusesRootIds,
      ticketCreatedAt,
      isInvoiced,
      isReopened
    } = this.props

    const tabProps = tabKey => ({
      selected: currentTab === tabKey,
      onClick: () => this.makeCurrentTab(tabKey),
      className: this.tabClassNames(tabKey)
    })

    const ticketShowHeaderStyle = {
      display: 'block'
    }

    const problemTicketLink = (associatedTimesheets, associatedTicket) => (
      <span>
        Associated Problem
        {' '}
        <a href={associatedTimesheets.associated_problem_path}>
          #
          {associatedTicket.problem.id}
        </a>
        {' '}
        Timesheets
      </span>
    )

    const ticketPdfExportPath = _.get(
      _.find(paths, { name: 'ticketPdfExport' }),
      'path'
    )

    const ticketWatcherPath = _.get(
      _.find(paths, { name: 'watcherPath' }),
      'path'
    )

    const onGoBackBreadcrumb = () => {
      if (_.includes(document.referrer, 'cloudhelp') || _.isEmpty(document.referrer)) {
        window.history.back()
        return
      }

      window.location = backLink
    }

    const watchTicket = () => {
      cloudhelpPost(ticketWatcherPath)
        .then((response) => {
          this.setState({
            showAlert: true,
            alertType: response.data.error ? 'error' : 'success',
            alertText: response.data.error ? response.data.error : response.data.success,
            ticketButtonStatus: response.data.status
          })
        })
    }

    return (
      <div>
        { hasNotices && hasRole('employee') && (
          <NoticesModal
            noticeAdmin={hasRole('notice', 'update')}
            itemType="ticket"
            itemId={ticket.id}
            ticketNotices={ticketNotices}
            ticketProblemNotices={ticketProblemNotices}
            ticketProblemId={ticketProblemId}
          />
        )}
        <header className="page-header" style={ticketShowHeaderStyle}>
          <div>
            <nav className="breadcrumbs flex">
              <a onClick={() => onGoBackBreadcrumb()}>
                <span className="breadcrumbs--last" style={{ cursor: 'pointer'}}>
                  Tickets
                </span>
              </a>
            </nav>
            <div className="page-header__inner-container">
              <h1
                className="page-header__title"
                onMouseEnter={e => (e.target.style.whiteSpace = 'normal')}
                onMouseLeave={e => (e.target.style.whiteSpace = '')}
              >
                {pageTitle}
              </h1>
              <div className="page-header__actions">
                { hasRole('timesheet', 'create') && _.isNull(ticket.primary_ticket_id) && (
                  <TicketTimesheetCreate
                    title="New Ticket Timesheet"
                    url={`/api/tickets/${ticket.id}/timesheets.json`}
                    method="post"
                    onClose={() => { this.closeModal() }}
                    regionId={ticket.region_id}
                    modalOpen={modalOpen}
                    serviceGroups={serviceGroups}
                    defaultServiceGroupId={defaultServiceGroupId}
                    hasManagedServiceGroup={hasManagedServiceGroup}
                    ticketStatuses={ticket_statuses}
                    ticketId={ticket.id}
                    contactName={ticket.contact_name}
                    ccOptions={watcherOptions}
                    statusesRootIds={statusesRootIds}
                    ticketCreatedAt={ticketCreatedAt}
                    shouldReload
                    isReopened={isReopened}
                    isReviewed={!_.isNull(ticket.reviewed_at)}
                    isInvoiced={isInvoiced}
                    ticketTypeId={ticket.ticket_type_id}
                  />
                )}
              </div>
            </div>
          </div>
        </header>

        {(ticket.assignee_user_id === null && hasRole('ticket', 'update')) && (
          <Alert type="notice">
            <span style={{ display: 'inline-flex' }}>
              <FormInputCheckbox id="assignMeOnNoExist" name="ticket[assignMeOnNoExist]" value={assignCurrentUser} onValue={() => this.setState({ assignCurrentUser: !assignCurrentUser })} />
              No assignee currently exists. Updating this ticket will automatically assign it to you.
            </span>
          </Alert>
        )}

        { (ticket.creationSource === 'email' && (ticket.contactAdditionalClients.length > 1)) && displayContactNotice && (
          <Alert type="notice" title="Client Contact belongs to following clients. Ask which client the ticket should belong to:" close={(e) => this.setState({ displayContactNotice: false })}>
            {_.map(ticket.contactAdditionalClients, client => (
              <li>{client}</li>
            ))}
          </Alert>
        )
        }
        { ticket.primary_ticket_id && (
          <Alert type="warning">
            <>
              This ticket has been merged into ticket
              {' '}
              <a href={ticket.parentTicketPath}>
                #
                {ticket.primary_ticket_id}
              </a>
              {' '} therefore it can't be updated anymore.
            </>
          </Alert>
        )
        }

        { hasRole('employee') && (
          <div className="flex flex--space-between">
            <div className="tabs">
              <Tab {...tabProps('details')}>
                Ticket information
              </Tab>
              <Tab {...tabProps('resourcing')}>
                Resourcing
              </Tab>
              { hasRole('invoicing', 'admin') && (
                <Tab {...tabProps('invoicing')}>
                  Invoice information
                </Tab>
              )}
              <Tab {...tabProps('timesheets')}>
                Timesheets
              </Tab>
              <Tab {...tabProps('assets')}>
                Configurations & services
              </Tab>
            </div>
            <div>
              <ActionButton
                size="compact"
                color="outline-secondary"
                className="button button--outline"
                actions={ticketInformationActions({
                  ticketButtonStatus: ticketButtonStatus,
                  watchTicket: watchTicket,
                  exportTicketPdf: `${ticketPdfExportPath}`
                })}
              >
                ACTIONS
              </ActionButton>
            </div>
          </div>
        )}

        <Row classExtra='no-gutters'>
          <Col width={currentTab !== 'invoicing' ? 15 : 24}>
            {showAlert && <Alert title={alertText} type={alertType} />}

            <TicketCorrespondence
              {...this.props}
              watcherOptions={watcherOptions}
              updateAlert={updateAlert}
              updateTicket={updateTicket}
              history={history}
              historyLoading={historyLoading}
              collectHistory={collectHistory}
              hidden={currentTab !== 'details'}
              assignCurrentUser={assignCurrentUser}
            />
            { hasRole('employee') && (
              <React.Fragment>
                <TicketResourcing
                  {...this.props}
                  watcherOptions={watcherOptions}
                  hidden={currentTab !== 'resourcing'}
                  collectHistory={collectHistory}
                />
                { hasRole('invoicing', 'admin') && (
                  <TicketInvoicing
                    {...this.props}
                    hidden={currentTab !== 'invoicing'}
                    timesheets={timesheets.ticket}
                  />
                )}
                <TicketTimesheets
                  {...this.props}
                  hidden={currentTab !== 'timesheets'}
                  timesheets={timesheets.ticket}
                  gatherTimesheets={getTimesheets}
                  loading={timesheetsLoading}
                  serviceGroups={serviceGroups}
                  title="Ticket Timesheets"
                  statusesRootIds={statusesRootIds}
                  ticketCreatedAt={ticketCreatedAt}
                />
                {_.size(timesheets.ticket_problem) > 0 && ticket.problem && (
                  <TicketTimesheets
                    {...this.props}
                    hidden={currentTab !== 'timesheets'}
                    title={problemTicketLink(timesheets, ticket)}
                    timesheets={timesheets.ticket_problem}
                    gatherTimesheets={getTimesheets}
                    loading={timesheetsLoading}
                    serviceGroups={serviceGroups}
                    statusesRootIds={statusesRootIds}
                    ticketCreatedAt={ticketCreatedAt}
                  />
                )}
                <TicketAssets
                  {...this.props}
                  hidden={currentTab !== 'assets'}
                />
              </React.Fragment>
            )}
          </Col>

          {currentTab !== 'invoicing' && (
            <Col width={9}>
              <TicketDetails
                {...this.props}
                collectHistory={collectHistory}
                updateAlert={updateAlert}
                updateTicket={updateTicket}
                ticket={ticket}
                assignCurrentUser={assignCurrentUser}
              />
            </Col>
          )}
        </Row>
      </div>
    )
  }
}

export default TicketShow
